import { Extension, Mark, mergeAttributes } from "@tiptap/core";
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";

import NoteImage from "components/organisms/note/extensions/NoteImage";
import NoteVideo from "components/organisms/note/extensions/NoteVideo";
import ReferenceCitation from "components/organisms/note/extensions/ReferenceCitation";

const StyledText = Mark.create({
    name: "styledText",

    addAttributes() {
        return {
            color: {
                default: null,
                parseHTML: (element) => element.style.color || null,
            },
            backgroundColor: {
                default: null,
                parseHTML: (element) => element.style.backgroundColor || null,
            },
        };
    },

    parseHTML() {
        return [{ tag: "span" }];
    },

    renderHTML({ HTMLAttributes }) {
        const { color, backgroundColor, style, ...rest } = HTMLAttributes;
        const styles = [
            style,
            color ? `color: ${color}` : null,
            backgroundColor ? `background-color: ${backgroundColor}` : null,
        ].filter(Boolean);

        return ["span", mergeAttributes(rest, styles.length ? { style: styles.join("; ") } : {}), 0];
    },

    addCommands() {
        return {
            setStyledText:
                (attributes) =>
                ({ commands }) =>
                    commands.setMark(this.name, attributes),
            unsetStyledText:
                () =>
                ({ commands }) =>
                    commands.unsetMark(this.name),
        };
    },
});

const TextAlign = Extension.create({
    name: "textAlign",

    addGlobalAttributes() {
        return [
            {
                types: ["heading", "paragraph"],
                attributes: {
                    textAlign: {
                        default: null,
                        parseHTML: (element) => element.style.textAlign || null,
                        renderHTML: (attributes) =>
                            attributes.textAlign ? { style: `text-align: ${attributes.textAlign}` } : {},
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setTextAlign:
                (textAlign) =>
                ({ commands }) => {
                    const paragraphUpdated = commands.updateAttributes("paragraph", { textAlign });
                    const headingUpdated = commands.updateAttributes("heading", { textAlign });
                    return paragraphUpdated || headingUpdated;
                },
            unsetTextAlign:
                () =>
                ({ commands }) => {
                    const paragraphUpdated = commands.resetAttributes("paragraph", "textAlign");
                    const headingUpdated = commands.resetAttributes("heading", "textAlign");
                    return paragraphUpdated || headingUpdated;
                },
        };
    },
});

export const createNoteExtensions = ({ getCitationLabel, getCitationReference } = {}) => [
    StyledText,
    TextAlign,
    Table.configure({
        resizable: true,
    }),
    TableRow,
    TableHeader,
    TableCell,
    ReferenceCitation.configure({ getCitationLabel, getCitationReference }),
    NoteImage,
    NoteVideo,
];

export const noteExtensions = createNoteExtensions();
